import ArrowRightDropdownItem from 'assets/svg/ArrowRightDropdownItem'
import { TLocaleCode } from 'constants/locales'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const SetupButton = ({
  label,
  href,
  notBorder,
}: {
  withLocale: boolean
  label: string
  href: string
  notBorder?: boolean
  includeLangsArr?: TLocaleCode[]
}) => {
  const [labelState, setLabelState] = useState(label)
  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }

  const handleMouseLeave = () => {
    setIsHover(false)
  }
  useEffect(() => {
    setLabelState(label)
  }, [label])

  const arrowStyle = {
    width: '16px',
    fill: isHover ? '#3071EE' : '#FFFFFF',
  }
  const arrowStyleNotBorder = {
    width: '16px',
    fill: '#FFFFFF',
  }

  return (
    <StyledSetupButton
      $notBorder={notBorder}
      href={href}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {labelState}{' '}
      {notBorder ? (
        <ArrowContainer>
          <ArrowRightDropdownItem style={notBorder ? arrowStyleNotBorder : arrowStyle} />
        </ArrowContainer>
      ) : (
        <ArrowRightDropdownItem style={notBorder ? arrowStyleNotBorder : arrowStyle} />
      )}
    </StyledSetupButton>
  )
}

export default SetupButton

const StyledSetupButton = styled.a<{ $notBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 0.875rem;
  font-family: ${({ theme }) => theme.font.gilroy};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 21px;
  color: ${({ theme }) => theme.colors.white};

  cursor: pointer;

  padding: 0.5rem 1rem;

  border: 1px solid ${({ theme }) => theme.colors.newLightColor.vividBlue};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.colors.newLightColor.vividBlue};

  transition: all 0.4s;

  &:hover {
    color: ${({ theme }) => theme.colors.newLightColor.vividBlue};
    background-color: ${({ theme }) => theme.colors.white};
  }

  [dir='rtl'] & {
    svg {
      transform: rotate(180deg);
    }
  }

  ${({ $notBorder }) =>
    $notBorder &&
    `
  font-size: 1rem;
  white-space: nowrap;
  
  background-color: transparent;
  border: none;

  color: #3071EE;
  cursor: pointer;
  
  gap: 0.5rem;
  padding: 0;
  
  &:hover {
    background-color: transparent;
  }
  
`}
`

const ArrowContainer = styled.div`
  display: flex;
  padding: 12.5px 8px;
  border-radius: 4px;
  height: 2rem;
  background-color: ${({ theme }) => theme.colors.newLightColor.vividBlue};
`
